<template>
  <div class="chat-history">
    <v-toolbar dense class="chat-history-toolbar">
      <v-text-field flat solo full-width clearable prepend-icon="search" label="Search"></v-text-field>
    </v-toolbar>  
    <vue-perfect-scrollbar class="chat-history--scrollbar">
      <v-divider></v-divider>             
      
        <v-tabs
      centered
      color="cyan"
      dark
      icons-and-text
    >
      <v-tabs-slider color="yellow"></v-tabs-slider>
  
      <v-tab href="#tab1">
        Single chats
        <v-icon>contacts</v-icon>
      </v-tab>
  
      <v-tab href="#tab2">
        Group chat
        <v-icon>group</v-icon>
      </v-tab>
  
      <v-tab-item
        tag="tab1"
        value="tab1"
         key="1"
      >
        <v-card flat>
          <v-card-text>
      
      <v-list two-line class="chat-history--list">
        <v-subheader>{{'chat._history_'|translate}}</v-subheader>
        <template v-for="(item, index) in chats" >
          <v-divider :key="index"></v-divider>
          <v-list-tile class="chat-list" avatar v-bind:key="item.title+index" :to="chatRoute(item.uuid)" >

              <v-avatar class="indigo mx-1" size="60">
                  <span v-if="item.avatar != null" class="white--text headline">{{ firstLetter(item.title)}}  </span>
                   <img  v-else v-bind:src="getAvatar(item.avatar)" alt="">
               </v-avatar>

            <v-list-tile-content>
              <v-list-tile-title> {{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title>{{item.last_message}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ formatChatTime(item.created_date) }}
              </v-list-tile-action-text>
              <v-icon style="font-size: 15px;" :color="chatStatusColor(item)">fiber_manual_record</v-icon>
              <!-- <v-circle dot small :color="chatStatusColor(item)"></v-circle> -->
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list> 
          </v-card-text>
        </v-card>
      </v-tab-item>
            <v-tab-item
       tag="tab2"
        value="tab2"
         key="2"
      >
        <v-card flat>
          <v-card-text>
      
        <v-list two-line class="chat-history--list">
        <v-subheader>{{'chat._history_'|translate}}</v-subheader>
        <template v-for="(item, index) in group_chats" >
          <v-divider :key="index"></v-divider>
          <v-list-tile class="chat-list" avatar v-bind:key="item.title+index" :to="chatRoute(item.uuid)" >

              <v-avatar class="indigo mx-1" size="60">
                   <v-icon class="white--text" >{{'chat._groups_'|translate}}</v-icon>
               </v-avatar>

            <v-list-tile-content>
              <v-list-tile-title> {{item.title}} ({{item.participants.length}})</v-list-tile-title>
              <v-list-tile-sub-title>{{item.last_message}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ formatChatTime(item.created_date) }}
              </v-list-tile-action-text>
              <v-icon style="font-size: 15px;" :color="chatStatusColor(item)">fiber_manual_record</v-icon>
              <!-- <v-circle dot small :color="chatStatusColor(item)"></v-circle> -->
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list> 

          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
      
 
    </vue-perfect-scrollbar>  
  </div>
</template>

<script>
// import { Groups } from '@/api/chat';
import VCircle from '@/components/circle/VCircle';
import Util from '@/theme/util';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  components: {
    VuePerfectScrollbar,
    VCircle
  },

  data: () => ({
    // chats: Groups,
  }),
  computed: {
    chats () {
      return this.$store.getters.convos;
    },
       group_chats () {
      return this.$store.getters.groups;
    }
  },

  methods: {
    chatRoute (id) {
      return '/chat/messaging/' + id;
      
    },
        firstLetter(name) {
          var fl = name.split(' ')[1].charAt(0) 
      return name.charAt(0)+fl;
    },
    formatChatTime (s) {
      return new Date(s).toLocaleDateString();
    },
    computeTitle (item) {
      
      // let username = (item.user_ids.length === 1) ? getUserById(item.user_ids[0]).username : '';
      // return item.user_ids.length === 1 ? username : item.title;
    },
    randomAvatarColor (item) {
      return item.users.length === 1 
        ? ''
        : Util.randomElement(['blue', 'indigo', 'success', 'error', 'pink']);
    },

    chatStatusColor (item) {
      
      let user = this.$store.getters.getUserById(item.users[0]);
      if(!this.isEmpty(user))
      {
      console.log(user) 
           return (user.online) ? 'success' : 'error';
      //return Util.randomElement(['blue', 'indigo', 'success', 'error', 'pink']);
    } else {
       return (false) ? 'success' : 'error';
    }
   },

    isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
  }  
};
</script>




// WEBPACK FOOTER //
// src/components/chat/ChatHistory.vue